<template>
  <div class="comment">
            <!-- <iframe width="100%"
                    height="380px"
                    src="https://520emv.com/oqmid-pay-tool-web/shop/evaluate/to-evaluate-order?isEvaluation=0"
                    frameborder="0"></iframe> -->
            <div class="comment-info clearfix">
              <div class="comment-percent fl"> <strong class="percent-tit">好评度</strong>
                <div class="percent-con">{{goodP}}<span>%</span> </div>
              </div>
              <div class="percent-info">
                <div class="tag-list">
                  <span class="tag" @click="filtrate(item.id)" v-for="(item,ind) in mjyxMap" :key="ind">{{item.name}}({{item.value}})</span>
                </div>
              </div>
            </div>
            <div class="comments-list">
              <div class="tab-main clearfix">
                <ul class="filter-list fl">
                  <li :class="index=='0'?'current':''"><a href="javascript:;" @click="filter('0')">全部评价<em>({{types[0].allEvaluation}})</em></a></li>
                  <li :class="index=='3'?'current':''"><a href="javascript:;"  @click="filter('3')">晒图<em>({{types[0].print}})</em></a></li>
                  <li :class="index=='2'?'current':''"><a href="javascript:;"  @click="filter('2')"> 追评<em>({{types[0].afterEvaluation}})</em></a></li>
                  <li :class="index=='4'?'current':''"><a href="javascript:;"  @click="filter('4')"> 好评<em>({{types[0].favorableComment}})</em></a></li>
                  <li :class="index=='5'?'current':''"><a href="javascript:;"  @click="filter('5')"> 中评<em>({{types[0].intermediateEvaluation}})</em></a></li>
                  <li :class="index=='6'?'current':''"><a href="javascript:;"  @click="filter('6')"> 差评<em>({{types[0].badReview}})</em></a></li>
                </ul>
                <ul class="sort-list clearfix fr">
                  <li :class="['fl',ind=='0'?'current ':'']" @click="filters('0')">默认排序</li>
                  <li :class="['fl',ind=='1'?'current ':'']" @click="filters('1')">时间排序</li>
                </ul>
              </div>
              <div class="tab-con" style="height:300px;overflow: auto;" v-if="true">
                <div class="comment-item" v-for="(item,ind) in product" :key="ind">
                  <!-- 用户信息 -->
                  <div class="user-info" v-if="item.cryptonym">
                    <img :src="'https://520emv.com/cme-sso-app/showimg/'+JSON.parse(item.avatar)[0].id"
                         alt="王宁">
                    <span>{{item.real_Name}}</span>
                  </div>
                  <div class="user-info" v-else>
                    <img :src="require('../../assets/image/images/default_media.png')" style="background-image:linear-gradient(30deg,#e1d5eb, #44b5ef);" />
                    <span>***</span>
                  </div>
                  <div class="comment-column">
                    <!-- 评分 -->
                    <el-rate
                      v-model="item.good_description"
                      disabled
                      show-score
                      :colors="['#0c78cf', '#0c78cf', '#0c78cf']"
                      text-color="#0c78cf">
                    </el-rate>
                    <p class="comment-con">
                      {{item.evaluation_content}}
                    </p>
                    <div class="pic-list">
                      <a class="current"
                         href="javascript:;"
                         v-for="ite in item.pictures"
                         :key="ite.id">
                        <img :src="ite">
                      </a>
                    </div>

                    <div class="comment-message clearfix">
                      <div class="message-l fl">
                        <a class="date"
                           href="javascript:;">{{item.create_time}} </a>
                        <!-- <a class="view"
                           href="javascript:;">44</a> -->
                      </div>
                      <div class="messaget-r fr">
                        <!-- <a @click.stop="showInp()"
                           class="replay"
                           href="javascript:;">52</a> -->
                        <a class="nice" @click="giveLike(item.id,item.like_number)"
                           href="javascript:;">{{item.like_number}}</a>
                        <!-- <a class="report"
                           href="javascript:;">举报</a> -->
                      </div>
                    </div>
                    <!-- 追评 -->
                    <div class="reply-items" v-if="item.superaddite_content||item.superaddite_pictures.length">
                      <div class="item">
                        <div class="tt">
                          <span class="name">
                            <em>{{item.real_Name}}</em>
                          </span>
                          {{item.superaddite_content}}
                        </div>
                        <div class="pic-list">
                          <a class="current"
                            href="javascript:;"
                            v-for="ite in item.superaddite_pictures"
                            :key="ite.id">
                            <img :src="ite">
                          </a>
                        </div>
                        <div class="tc clearfix">
                          <div class="time">{{item.superaddite_create_time}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
</template>
<script>
import ZImage from "../../components/ZImage.vue"
export default {
  name: 'xiangguanpingjia',
  components:{
    ZImage
  },
  props: {
    contentId:String
  },
  data () {
    return {
      num:0,
      mjyxMap:[{name:'质量好',value:'0'},{name:'服务好',value:'0'},{name:'老板热心',value:'0'},{name:'沟通流畅',value:'0'},{name:'严肃认真',value:'0'},{name:'工期延误',value:'0'},{name:'交付准时',value:'0'},{name:'业务有待提高',value:'0'},{name:'不送货上门',value:'0'},{name:'未收货已签收',value:'0'},{name:'服务态度不好',value:'0'},{name:'多收取费用',value:'0'}],
      types:[{print:'0',afterEvaluation:'0',allEvaluation:'0',badReview:'0',favorableComment:'0',intermediateEvaluation:'0'}],
      product:[],
      goodP:0,
      index:0,
      ind:0
    }
  },
  mounted () {
    this.getEvaluation();
  },
  methods: {
    filter(ind){
      this.index = ind;
      this.num = ind;
      this.getEvaluation();
    },
    filters(ind){
      this.ind = ind;
      this.num = ind;
      this.getEvaluation();
    },
    //筛选
    filtrate(id){
      this.num = id;
      this.getEvaluation();
    },
    //点赞数量
    giveLike(id,num){
      var _this = this;
      _this.$http.get("/oqmid-pay-tool-web/shop/evaluate/giveLike", {
        id: id,
        likeNumber: num
      }).then(res => {
        _this.getEvaluation();
      })
    },
    //获取评论信息
    getEvaluation(){
      var _this = this;
      _this.$http.get("/oqmid-pay-tool-web/shop/evaluate/getProductEvaluateById.json", {
        productId: _this.contentId,
        // productId: '579562988042846208',
        orderType: _this.num
      }).then(res => {
        if(res.state==1){
          _this.goodP = res.data.evaluationNumber*100;
          _this.mjyxMap = res.data.mjyxMap;
          var product = res.data.product;
          if(product){
            product.forEach(element => {
              if(element.pictures){
                element.pictures = element.pictures.split(',');
              }
              if(element.superaddite_pictures){
                element.superaddite_pictures = element.superaddite_pictures.split(',');   
              }
            });
          }
          _this.product = product;
          _this.types = res.data.types;
        }
      })
    }
  }
}
</script>
<style scoped>
  @import "../../assets/css/evaluation.css";
</style>




// WEBPACK FOOTER //
// src/components/floorBlock/xiangguanpingjia.vue